// extracted by mini-css-extract-plugin
export default {"titleBox":"logoName_titleBox__Ce9oR","title":"logoName_title__kF7UI"};